// extracted by mini-css-extract-plugin
export default {"error":"AssignAnimalsToGroup_error__4JIL-"};